/* oxlint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import iconSet from 'quasar/icon-set/svg-mdi-v7.js'

import {QSpinnerDots,Loading,Notify,Dialog,LocalStorage,Dark,Meta} from 'quasar'

const userOptions = { config: {"loading":{"spinnerSize":64,"spinner":"QSpinnerDots","delay":400}},iconSet,components: {QSpinnerDots},plugins: {Loading,Notify,Dialog,LocalStorage,Dark,Meta} }
userOptions.config.loading.spinner = QSpinnerDots

export default userOptions
